import React from 'react'
export default function RefreshPagePipe () {
  window.location.reload()

  return null;
}
